import { type KpiPayload } from '../../shared/kpi';

export type Lamp = { level: 'ok' | 'warn' | 'bad'; reason: string };

/**
 * Ampel für die Übersichtskarte.
 *
 * Bewusst regelbasiert und **im Code nachlesbar** – keine KI-Bewertung. Die
 * Ampel zeigt Zustände der Pipeline, nicht Urteile über Menschen: „vier Deals
 * liegen seit über einer Woche" ist eine Tatsache über Datensätze, „schwache
 * Leistung" wäre eine Behauptung über eine Person.
 *
 * Die Begründung wird immer mitgeliefert. Eine Farbe ohne Grund wäre eine
 * Aufforderung, sich etwas dazuzudenken.
 */
export function lampFor(payload: KpiPayload): Lamp {
  const stale = payload.stale.length;
  const noNotes = payload.notesWeek === 0 && payload.openDealCount > 0;

  if (stale >= 5) {
    return { level: 'bad', reason: `${stale} Vorgänge liegen geblieben` };
  }
  if (noNotes) {
    return { level: 'bad', reason: 'keine Notiz diese Woche' };
  }
  if (stale > 0) {
    return { level: 'warn', reason: `${stale} ${stale === 1 ? 'Vorgang liegt' : 'Vorgänge liegen'} geblieben` };
  }
  return { level: 'ok', reason: 'nichts Auffälliges' };
}
